import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Alert from "@shared/v2/Alert";
import Spinner from "@icons/Spinner";
import * as api from "./actions/api";
import BrandingCard from "./components/BrandingCard";
import OfficeCards from "./components/OfficeCards";
import ReviewCard from "./components/ReviewCard";
import SocialCard from "./components/SocialCard";
import TeamCard from "./components/TeamCard";

const Main = () => {
  const dispatch = useDispatch();
  const hasError = useSelector((state) => state.businessSettings.hasError);
  const isLoading = useSelector((state) => state.businessSettings.isLoading);
  const model = useSelector((state) => state.businessSettings.model);
  useEffect(() => {
    dispatch(api.loadBusinessSettings());
  }, []);

  if (isLoading) {
    return (
      <div className="tw-pt-[90px] tw-text-center">
        <Spinner size="xxxl" className="fa-spin" />
      </div>
    );
  }

  return (
    <div className="tw-p-[16px] tw-bg-tinted-gray-50 tw-flex tw-flex-wrap tw-gap-[16px] tw-max-w-[1200px] tw-mx-auto">
      {(hasError || !model) && (
        <Alert
          containerClass="tw-w-full"
          variant="error"
          title="Something went wrong"
          text="Failed to load business settings. Try again later."
        />
      )}
      {model && (
        <>
          <TeamCard />
          <BrandingCard />
          <OfficeCards />
          <SocialCard />
          <ReviewCard />
        </>
      )}
      <input
        type="text"
        className="tw-h-[1px] tw-w-[1px] tw-absolute tw-top-[-100%] tw-left-[-100%]"
        id="businessCopyInput"
      />
    </div>
  );
};

export default Main;
